import React, { Children, memo } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import { sidebarMenuExpanded, useStore } from "../../helpers";
import { ReactRouterLink } from "../Link";
import SidebarItem from "./SidebarItem";
const sxStyles = ({ spacing, transitions }) => ({
    navSub: {
        margin: 0,
        padding: 0,
        width: spacing(27 - 0.25),
        transitionDelay: `${transitions.duration.complex}ms`,
    },
    navSubVisible: {
        transitionDelay: "0ms",
    },
    itemMargin: {
        paddingTop: "15px",
        paddingBottom: "15px",
        paddingLeft: "24px",
    },
    itemBorder: {
        borderLeft: "1px solid #ffffff",
        paddingTop: "1px",
        paddingBottom: "1px",
    },
    itemLineMargin: {
        marginTop: "-20px",
        marginBottom: "-20px",
        paddingLeft: "20px",
    },
});
const SidebarDropdown = ({ icon, label, children, active, to = "", ListItemTextProps, ListItemButtonProps, CollapseProps, linkComponent: LinkComponent = ReactRouterLink, sx, ...other }) => {
    const isExpanded = useStore(sidebarMenuExpanded);
    const hasSubmenuItems = Children.toArray(children).length >= 1 && active;
    return (React.createElement(React.Fragment, null,
        React.createElement(SidebarItem, { label: label, selected: active, isParent: hasSubmenuItems, to: to, icon: icon, ListItemButtonProps: ListItemButtonProps, ListItemTextProps: ListItemTextProps, linkComponent: LinkComponent, sx: sx, ...other }),
        React.createElement(Collapse, { ...CollapseProps, className: CollapseProps?.className, sx: (theme) => ({
                ...sxStyles(theme).navSub,
                ...(isExpanded && sxStyles(theme).navSubVisible),
            }), in: (isExpanded && active) || isExpanded },
            React.createElement(Box, { sx: (theme) => sxStyles(theme).itemMargin },
                React.createElement(Box, { sx: (theme) => sxStyles(theme).itemBorder },
                    React.createElement(Box, { sx: (theme) => sxStyles(theme).itemLineMargin }, children))))));
};
export default memo(SidebarDropdown);
//# sourceMappingURL=SidebarDropdown.js.map